import React from 'react';
import {
  Box,
  GDSStyleObject,
  ParagraphText,
  queryHelpers,
  useMediaQuery,
} from '@leagueplatform/genesis-core';
import { Accordion } from '@leagueplatform/web-common-components';
import { EVENT_NAME, trackAnalyticsEvent } from '@leagueplatform/analytics';
import * as constants from '../../../common/constant';

export function CostAccordionComponent(props: any) {
  const { costContent } = props;
  const isBelow400 = useMediaQuery(queryHelpers.down(400));
  const trackAnalytics = (
    buttonName: string,
    product: string,
    accordionState: string,
    event: Event,
  ) => {
    if (
      (event?.currentTarget as HTMLInputElement).getAttribute('data-state') ===
      'closed'
    ) {
      trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
        product_area: product,
        screen_name: `${constants.ANALYTICS_SCREEN_NAME} - ${constants.ANALYTICS_COST}`,
        detail: `toggle ${buttonName} accordion`,
        sub_detail: accordionState,
        path: window.location.pathname,
        event_author: constants.ENGEN,
      });
    } else {
      trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
        product_area: product,
        screen_name: `${constants.ANALYTICS_SCREEN_NAME} - ${constants.ANALYTICS_COST}`,
        detail: `toggle ${buttonName} accordion`,
        sub_detail: 'collapse',
        path: window.location.pathname,
        event_author: constants.ENGEN,
      });
    }
  };

  return (
    <Accordion.Root
      type="single"
      defaultValue="0"
      data-testid="faqPanel"
      collapsible
      css={{
        '& .GDS-button:focus': {
          outline: 0,
          border: '3px solid #0074C9',
          backgroundColor: '$surfaceBackgroundPrimary',
          '@mobile': {
            width: '100% !important',
          },
        },
        '& .GDS-button:hover': {
          outline: 0,
          backgroundColor: '$surfaceBackgroundTertiary',
        },
      }}
    >
      {costContent?.breakdown.types?.map((item: any, index: number) => (
        <Accordion.Item
          key={`${item?.title}`}
          value={`${index}`}
          css={{
            marginTop: '$none !important',
            marginBottom: '$oneAndHalf',
            visited: {
              border: '1px solid #000000 !important',
            } as GDSStyleObject,
          }}
          data-testid={item.title}
        >
          <Accordion.Header
            css={
              {
                height: '24px',
                borderRadius: '0px',
                border: '0px solid #000000 !important',
                '@desktop': {
                  borderRadius: '0px',
                },
                '@mobile': {},
              } as GDSStyleObject
            }
            data-testid={`${item.title}-1`}
            onClick={(event: Event) =>
              trackAnalytics(
                item?.title,
                constants.ANALYTICS_PRODUCT_AREA,
                'expand',
                event,
              )
            }
            level="3"
          >
            <Box
              css={{
                borderBottom: '0px solid $onSurfaceBorderSubdued',
                marginTop: '$half',
                '@mobile': {},
              }}
            >
              <Accordion.Trigger
                css={
                  {
                    color: '$onSurfaceTextPrimary',
                    fontWeight: '$buttonOne !important',
                    LineHeight: '24px',
                    fontSize: '$headingFour !important',
                    borderRadius: '0px',
                    padding: '$half $quarter $half $none !important',
                    fontFamily: '$headingFour',
                    lineHeight: '$buttonOne !important',
                    letterSpacing: '$headingFour',
                    gap: '$half',
                    height: '24px',
                    '@desktop': {
                      width: '714px',
                    },
                    '@mobile': {},
                  } as GDSStyleObject
                }
              >
                {item?.title}
              </Accordion.Trigger>
            </Box>
          </Accordion.Header>
          <Accordion.Content>
            <Box
              css={
                {
                  width: '295px',
                  textAlign: 'justify',
                  fontWeight: '$subtitleOne',
                  fontSize: '$one',
                  lineHeight: '24px',
                  backgroundColor: '$surfaceBackgroundSecondary',
                  borderBottom: '1px solid $onSurfaceBorderSubdued !important',
                  marginTop: '-9px',
                  padding: '$one $oneAndHalf',
                  borderRadius: '2px',
                  '@desktop': {
                    padding: '$one $oneAndHalf',
                    marginTop: '-9px',
                  },
                  '@tablet': {
                    padding: '$one $oneAndHalf',
                    textAlign: 'justify',
                  },
                  '@mobile': {
                    padding: '$one $oneAndHalf',
                    marginLeft: '-1px',
                  },
                } as GDSStyleObject
              }
            >
              <ParagraphText
                css={{
                  fontSize: '$bodyTwo',
                  fontWeight: '$bodyOne',
                  lineHeight: '$subtitleTwo',
                  '@desktop': { width: '676px' },
                  '@mobile': {
                    width: isBelow400 ? '339px' : '380px',
                  },
                }}
              >
                {item?.charges}
              </ParagraphText>
            </Box>
          </Accordion.Content>
        </Accordion.Item>
      ))}
    </Accordion.Root>
  );
}
